import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowLeft, Shield } from 'lucide-react';
import { FigIcon } from '../components/FigIcon';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#E8E4DC]">
      <header className="fixed top-0 left-0 right-0 z-50 glass">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#525252] hover:text-[#1A1C19]">
            <ArrowLeft className="w-4 h-4" />
            Home
          </Link>
          <div className="flex items-center gap-2">
            <FigIcon className="w-6 h-6 text-[#2F3E30]" />
          </div>
        </div>
      </header>

      <main className="pt-24 pb-12 px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <Shield className="w-8 h-8 text-[#2F3E30]" />
            <h1 className="text-3xl font-bold" style={{ fontFamily: 'Libre Baskerville, serif' }}>PRIVACY POLICY</h1>
          </div>

          <div className="prose prose-invert prose-sm max-w-none space-y-6 text-[#525252]">
            <p className="text-[#1A1C19]">Last updated: {new Date().toLocaleDateString()}</p>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>1. INFORMATION WE COLLECT</h2>
              <p>We collect information you provide directly to us, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Account information (email, optional name)</li>
                <li>Health questionnaire responses (age, measurements, lifestyle data)</li>
                <li>Weekly check-in data</li>
                <li>Payment information (processed securely by Stripe)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>2. HOW WE USE YOUR INFORMATION</h2>
              <p>We use the information we collect to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Calculate your metabolic trajectory score</li>
                <li>Generate personalized correction plans</li>
                <li>Track your progress over time</li>
                <li>Send you service-related communications</li>
                <li>Improve our scoring algorithms (anonymized data only)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>3. DATA SECURITY</h2>
              <p>
                We implement appropriate security measures to protect your personal information. 
                Your data is encrypted in transit and at rest. We never share your individual 
                health data with third parties.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>4. YOUR RIGHTS (GDPR)</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Access</strong> your personal data</li>
                <li><strong>Export</strong> your data in a portable format</li>
                <li><strong>Delete</strong> your account and all associated data</li>
                <li><strong>Withdraw consent</strong> at any time</li>
              </ul>
              <p>
                You can exercise these rights through your account settings or by contacting us 
                at support@trajectory.health.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>5. DATA RETENTION</h2>
              <p>
                We retain your data for as long as your account is active. When you delete your 
                account, all personal data is permanently removed within 30 days.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>6. COOKIES</h2>
              <p>
                We use essential cookies only for authentication and session management. 
                We do not use tracking cookies or share data with advertising networks.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-[#1A1C19]" style={{ fontFamily: 'Libre Baskerville, serif' }}>7. CONTACT</h2>
              <p>
                For any privacy-related questions, contact us at: support@trajectory.health
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
